import React from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import { FB_URL } from "../store/actions/types";
import CryptoPriceColumn from "./CryptoPriceColumn";
import MEVPriceGraph from "./MEVPriceGraph";
import MEVPriceGraphB from "./MEVPriceGraphBetter";

class RealMEVChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        labels: [], // Time values
        datasets: [
          {
            label: "MEV Price (USD)",
            data: [], // Price values
            borderColor: "rgba(75,192,192,1)",
            backgroundColor: "rgba(75,192,192,0.2)",
            fill: true,
            tension: 0.4,
          },
        ],
      },
    };
    this.interval = null;
  }

  componentDidMount() {
    this.getMEVprice(); // Fetch initial data
    this.interval = setInterval(this.getMEVprice, 60000); // Fetch data every minute
  }

  componentWillUnmount() {
    clearInterval(this.interval); // Clear interval on unmount
  }

  getMEVprice = async () => {
    try {
      const blank = "";
      const res = await axios.post(`${FB_URL}/m110-getmevprice`, {
        aaa: blank,
        bbb: blank,
        ccc: blank,
      });

      const MEVprice = res.data.MEVprice;
      const currentTime = new Date().toLocaleTimeString();

      // Update the chart's state with new data
      this.setState((prevState) => {
        const updatedLabels = [...prevState.data.labels, currentTime];
        const updatedData = [
          ...prevState.data.datasets[0].data,
          parseFloat(MEVprice),
        ];

        return {
          data: {
            labels: updatedLabels.slice(-10), // Limit to the last 10 points
            datasets: [
              {
                ...prevState.data.datasets[0],
                data: updatedData.slice(-10),
              },
            ],
          },
        };
      });
    } catch (error) {
      // Handle error silently
    }
  };

  render() {
    return (
      <div>
        <h2>MEV Token Price Ticker</h2>
        <Line data={this.state.data} />
        <MEVPriceGraph/>
        <MEVPriceGraphB />
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <CryptoPriceColumn />
      </div>
    </div>
    );
  }
}

export default RealMEVChart;
